import React, { Component } from 'react';
import { Field, Formik } from 'formik';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isValidNumber } from 'libphonenumber-js';
import { inject } from 'mobx-react';
import { toast } from 'react-toastify';
import ModalAlert from '../../components/ui-toolkit/modal.js';
import {
	FormCheckBoxHTML,
} from '../../components/ui-toolkit/form-inputs.js';
import { TertiaryButton } from '../../components/ui-toolkit/buttons.js';
import FormPhoneInput from '../../components/ui-toolkit/form-phone-input.js';
import UserAccountService from '../user-account/user-account.service.js';
import User from '../../shared/user.model.js';
import Utils from '../../components/shared/util.js';
import './accept-terms.modal.scss';

class AcceptTermsModal extends Component {
	render() {
		const {
			openModal, hasPhoneNumber, languageStore: { region: lang }, intl,
		} = this.props;

		return (
			<ModalAlert
				centered
				isOpen={openModal}
				className="accept-terms-modal"
			>
				<h1>{hasPhoneNumber ? <FormattedMessage id="accept_terms.accept_terms" /> : <FormattedMessage id="accept_terms.complete_profile" />}</h1>

				<Formik
					initialValues={{
						phoneNumber: '',
						legalDocumentAccept: false,
					}}
					onSubmit={(values, { setSubmitting, resetForm }) => {
						const { userStore } = this.props;
						const { user } = userStore;

						setSubmitting(true);

						if (hasPhoneNumber) {
							// accept terms
							UserAccountService.acceptTermsConditions()
								.then(() => {
									resetForm(values);
									setSubmitting(false);
									userStore.storeUser(new User({ ...user, termsAcceptance: true }));

									Utils.showMessageAlert('accept_terms.accept_terms_success',
										toast.TYPE.SUCCESS,
										intl.formatMessage({
											id: 'accept_terms.accept_terms_success',
										}));
								})
								.catch((error) => {
									Utils.showErrorMessageAlert(error, toast.TYPE.ERROR, intl);
									setSubmitting(false);
								});
						} else {
							// accept terms and update profile
							const updateUserProfileValues = {
								avatar: user.avatar,
								country: user.country,
								email: user.email,
								firstName: user.firstName,
								id: user.id,
								langCode: user.langCode,
								lastName: user.lastName,
								phoneNumber: values.phoneNumber,
							};

							Promise.all([
								UserAccountService.acceptTermsConditions(),
								UserAccountService.updateProfile(updateUserProfileValues),
							])
								.then(() => {
									resetForm(values);
									setSubmitting(false);
									userStore.storeUser(new User({ ...user, ...updateUserProfileValues, termsAcceptance: true }));

									Utils.showMessageAlert('accept_terms.complete_profile_success',
										toast.TYPE.SUCCESS,
										intl.formatMessage({
											id: 'accept_terms.complete_profile_success',
										}));
								})
								.catch((error) => {
									Utils.showErrorMessageAlert(error, toast.TYPE.ERROR, intl);
									setSubmitting(false);
								});
						}
					}}
				>
					{({
						errors, dirty, touched, handleSubmit, isSubmitting, isValid,
					}) => (
						<form onSubmit={handleSubmit} noValidate>
							{!hasPhoneNumber
							&& (
								<Field
									name="phoneNumber"
									component={FormPhoneInput}
									label={intl.formatMessage({
										id: 'accept_terms.phone_number',
									})}
									placeholder={intl.formatMessage({
										id: 'sign_up.phone_number',
									})}
									error={errors.phoneNumber && touched.phoneNumber}
									validate={(value) => {
										let errorMessage;
										if (!(value && isValidNumber(value))) {
											errorMessage = intl.formatMessage({
												id: 'sign_up.invalid_phoneNumber',
											});
										}
										return errorMessage;
									}}
									validationMessage={errors.phoneNumber}
								/>
							)}

							<Field
								component={FormCheckBoxHTML}
								name="legalDocumentAccept"
								className="privacy-policy"
								label={intl.formatMessage({ id: 'sign_up.dataPrivacyPolicy' }, {
									privacyPolicy: `${process.env.REACT_APP_API_URL}/api/legaldocument/download?documentType=data.privacy.policy&lang=${lang}`,
									gdpr: `${process.env.REACT_APP_API_URL}/api/legaldocument/download?documentType=personal.data.processing.agreement&lang=${lang}`,
								})}
								ariaLabel={intl.formatMessage({ id: 'sign_up.dataPrivacyPolicy' }, {
									privacyPolicy: `${process.env.REACT_APP_API_URL}/api/legaldocument/download?documentType=data.privacy.policy&lang=${lang}`,
									gdpr: `${process.env.REACT_APP_API_URL}/api/legaldocument/download?documentType=personal.data.processing.agreement&lang=${lang}`,
								})}
								error={errors.legalDocumentAccept && touched.legalDocumentAccept}
								validate={value => !value}
								validationMessage={errors.legalDocumentAccept}
							/>

							<TertiaryButton
								fullWidth
								type="submit"
								disabled={!dirty || !isValid || isSubmitting}
								onClick={handleSubmit}
							>
								<FormattedMessage id="accept_terms.continue" />
							</TertiaryButton>
						</form>
					)}
				</Formik>
			</ModalAlert>
		);
	}
}

export default injectIntl(inject('userStore', 'languageStore')(AcceptTermsModal));
